/** LaunchDarkly `product` context attribute for the workspace. */
export const WORKSPACE_LD_PRODUCT = 'developer-platform'

/** Query param set by product apps when they link into the workspace. */
export const SOURCE_QUERY_PARAM = 'from'

export const WORKSPACE_MODULE_NAME = 'SAIVA Developers'

/**
 * Whether the workspace sends its own Mixpanel events (SAIV-11356). Off
 * unless `VITE_DEVELOPER_PLATFORM_ANALYTICS=true`: nobody uses them yet and
 * staging's Mixpanel proxy rejects them with 503 (SAIV-11642).
 */
export const WORKSPACE_ANALYTICS_ENABLED =
  import.meta.env.VITE_DEVELOPER_PLATFORM_ANALYTICS === 'true'
